import React, { useEffect, useState } from "react";
import "../Assets/Css/Table.scss";
import TableRow from "./TableRow";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { customStyle } from "./Style";
import Select from "react-select";
import queryString from "query-string";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "react-bootstrap";
const options = [
  { value: 5, label: 5 },
  { value: 10, label: 10 },
  { value: 15, label: 15 },
  { value: 20, label: 20 },
];
const Table = (props) => {
  const header = props.header;
  const data = props.data;
  const footer = props.footer;
  const count = props.count;
  const records = props.records;
  const totalSelectedIds = props.totalSelectedIds;
  const [modelData, setModelData] = useState({});
  const [show, setShow] = useState(false);
  const checked = props.checked;
  const selectedId = props.selectedId;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const navigate = useNavigate();
  const location = useLocation();
  const showIsView = props.showIsView;
  const showIsDelete = props.showIsDelete;
  const showIsDownload = props.showIsDownload;
  const isDownloadSalarySlip = props.isDownloadSalarySlip;
  const showIsProgressChart = props.showIsProgressChart;
  const showIsApprove = props.showIsApprove;
  const showIsReject = props.showIsReject;
  const showIsTimesheet = props.showIsTimesheet;
  const showIsEdit = props.showIsEdit;
  const showIsReply = props.showIsReply;
  const onRowClick = props.onRowClick;
  const idsArray = data?.map((row) => {
    return row?.invoiceId?.value || row?.checkbox?.value;
  });
  const [selectedOption, setSelectedOption] = useState(options[3]);
  const totalPages = Math.ceil(records / (props?.totalRecordsToShow ? props?.totalRecordsToShow : limit));
  const startIndex = (page - 1) * (props?.totalRecordsToShow ? props?.totalRecordsToShow : limit);
  const endIndex = page == 1 ? Math.min(startIndex + (props?.totalRecordsToShow ? props?.totalRecordsToShow : limit), count) : startIndex + count
  const handleClose = () => {
    setShow(false);
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = (newLimit) => {
    setLimit(newLimit.value);
    setSelectedOption(newLimit);
    setPage(1);
  };
  useEffect(() => {
    if (footer === true) {
      let otherParams = queryString.parse(location.search);
      let params = { ...otherParams };
      params.limit = (props?.totalRecordsToShow ? props?.totalRecordsToShow : limit);
      params.page = page;
      const stringParams = queryString.stringify(params);
      location?.state?.data?.allData ? navigate(`?${stringParams}`, { state: { data: { allData: location?.state?.data?.allData } } }) : navigate(`?${stringParams}`)
    }
  }, [page, (props?.totalRecordsToShow ? props?.totalRecordsToShow : limit)]);
  return (
    props.loading ?
      <div style={{
        display: "flex",
        justifyContent: "center",
        width: "100%"
      }}>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      </div>
      :
      <div className="table-main">
        <table className="table-container">
          <thead className="table-head">
            <tr className="table-header-row">
              {header.map((col, index) => {
                if (col.field === "Sr No") {
                  return (
                    <th className="table-header-th" key={index}>
                      #
                    </th>
                  );
                } else if (col.field === "checkbox") {
                  return (
                    <th className="table-header-th" key={index}>
                      <input
                        type="checkbox"
                        id={`headerAll`}
                        checked={
                          idsArray?.length > 0 &&
                          idsArray.every(id => (totalSelectedIds || []).includes(id))
                        }
                        onChange={(e) => {
                          props.handleChange({
                            type: "select-all",
                            checked: e.target.checked,
                            ids: idsArray,
                          });
                        }}
                      />
                    </th>
                  );
                }
                return <th className="table-header-th">{col.field}</th>;
              })}
            </tr>
          </thead>
          <tbody className="table-body">
            {data?.length > 0 ?
              (endIndex ?
                (data?.slice(startIndex, endIndex)?.map((row, index) => (
                  <TableRow
                    key={index}
                    setShow={setShow}
                    setModelData={setModelData}
                    data={row}
                    features={props?.features}
                    modules={props?.modules}
                    user={props?.user}
                    ModuleNameForEdit={props?.ModuleNameForEdit}
                    Featur_NameForEedit={props?.Featur_NameForEedit}
                    ModuleNameForView={props?.ModuleNameForView}
                    Featur_NameForView={props?.Featur_NameForView}
                    ModuleNameForDelete={props?.ModuleNameForDelete}
                    Featur_NameForDelete={props?.Featur_NameForDelete}
                    index={index}
                    header={header}
                    checked={checked}
                    selectedId={selectedId}
                    totalSelectedIds={totalSelectedIds}
                    handleChange={props.handleChange}
                    idsArray={idsArray}
                    showIsView={showIsView}
                    showIsDelete={showIsDelete}
                    showIsDownload={showIsDownload}
                    isDownloadSalarySlip={isDownloadSalarySlip}
                    showIsProgressChart={showIsProgressChart}
                    showIsReject={showIsReject}
                    showIsTimesheet={showIsTimesheet}
                    showIsEdit={showIsEdit}
                    showIsApprove={showIsApprove}
                    showIsReply={showIsReply}
                    setFields={props.setFields}
                    IsStopTimer={props?.IsStopTimer}
                    TaskApprove={props?.TaskApprove}
                    updateTask={props?.updateTask}
                    deleteRecord={props?.deleteRecord}
                    updateLeave={props?.updateLeave}
                    updateAward={props?.updateAward}
                    updateTicket={props?.updateTicket}
                    TaskStatus={props?.TaskStatus}
                    onRowClick={props.onRowClick}
                    rowClickType={props.rowClickType || "modal"}
                  />
                ))) : (data?.map((row, index) => (
                  <TableRow
                    key={index}
                    setShow={setShow}
                    setModelData={setModelData}
                    data={row}
                    index={index}
                    header={header}
                    checked={checked}
                    selectedId={selectedId}
                    totalSelectedIds={totalSelectedIds}
                    handleChange={props.handleChange}
                    idsArray={idsArray}
                    features={props?.features}
                    modules={props?.modules}
                    user={props?.user}
                    ModuleNameForView={props?.ModuleNameForView}
                    Featur_NameForView={props?.Featur_NameForView}
                    ModuleNameForEdit={props?.ModuleNameForEdit}
                    Featur_NameForEedit={props?.Featur_NameForEedit}
                    ModuleNameForDelete={props?.ModuleNameForDelete}
                    Featur_NameForDelete={props?.Featur_NameForDelete}
                    showIsView={showIsView}
                    showIsDelete={showIsDelete}
                    showIsDownload={showIsDownload}
                    isDownloadSalarySlip={isDownloadSalarySlip}
                    showIsProgressChart={showIsProgressChart}
                    showIsReject={showIsReject}
                    showIsTimesheet={showIsTimesheet}
                    showIsEdit={showIsEdit}
                    showIsApprove={showIsApprove}
                    showIsReply={showIsReply}
                    setFields={props.setFields}
                    IsStopTimer={props?.IsStopTimer}
                    TaskApprove={props?.TaskApprove}
                    updateTask={props?.updateTask}
                    deleteRecord={props?.deleteRecord}
                    updateLeave={props?.updateLeave}
                    updateAward={props?.updateAward}
                    updateTicket={props?.updateTicket}
                    TaskStatus={props?.TaskStatus}
                    onRowClick={props.onRowClick}
                    rowClickType={props.rowClickType || "modal"}
                  />
                )))) :
              <tr>
                <td colSpan={header.length.toString()} style={{
                  textAlign: "center",
                  padding: "10px 0"
                }}>No Records</td>
              </tr>}
          </tbody>
        </table>
        {footer ? (
          <div className="table-footer">
            <div className="footer-container">
              <div className="foot-left-part"></div>
              <p className="text-footer">Rows per Pages:</p>
              <div className="selection-part">
                <Select
                  defaultValue={selectedOption}
                  onChange={handleLimitChange}
                  options={options}
                  placeholder={"Client"}
                  styles={customStyle}
                  menuPlacement="top"
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
              </div>
              <p className="showRowCount">
                {" "}
                {startIndex}-{endIndex} of {count}
              </p>
              <div className="buttonCollection">
                <button
                  className="buttonAll"
                  onClick={() => {
                    if (page === 1) {
                      handlePageChange(page);
                    } else {
                      handlePageChange(page - 1);
                    }
                  }}
                >
                  <AiOutlineLeft size={18} />
                </button>
                {page < totalPages ? <button
                  className="buttonAll"
                  onClick={() => {
                    handlePageChange(page + 1);
                  }}
                >
                  <AiOutlineRight />
                </button> : <button
                  className="buttonAll"
                  disabled
                >
                  <AiOutlineRight size={18} />
                </button>}
              </div>
            </div>
          </div>
        ) : null}
        <Modal
          show={show}
          onHide={handleClose}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              View full details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid details-model">
            <Container>
              <Row>
                <Col lg={6} md={6}>
                  Name: <br />
                  {modelData.name}
                </Col>
                <Col lg={6} md={6}>
                  Email: <br />
                  {modelData.email}
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={6} md={6}>
                  Phone Number: <br />
                  {modelData.phoneNumber}
                </Col>
                <Col lg={6} md={6}>
                  Subject: <br />
                  {modelData.subject}
                </Col>
              </Row>
              <hr />
              <Row>
                <Col lg={12} md={12}>
                  Description: <br />
                  {modelData.description}
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </div>
  );
};
export default Table;